import { getQueryStringFromObject as s } from "@partoohub/utils";
import { ApiResourceBaseClass as n } from "./baseApiCalls.js";
const r = "presence_analytics", a = "metrics", c = "keywords";
class $ extends n {
  /**
   * Exports metrics based on the provided query parameters.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/presence_analytics/metrics/export?${queryParams}`
   *
   * @param {ExportMetricRequestParams} queryParams - An object containing the query parameters for the export request.
   * @returns {Promise<SuccessResponse>} A promise that resolves to an object containing the status of the export operation.
   */
  exportMetrics = async (t) => {
    const { data: e } = await this.get(
      `${r}/${a}/export?${s(
        t
      )}`
    );
    return e;
  };
  /**
   * Exports keywords based on the provided query parameters.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/presence_analytics/keywords/export?${queryParams}`
   *
   * @param {ExportKeywordRequestParams} queryParams - An object containing the query parameters for the export request.
   * @returns {Promise<SuccessResponse>} A promise that resolves to an object containing the status of the export operation.
   */
  exportKeywords = async (t) => {
    const { data: e } = await this.get(
      `${r}/${c}/export?${s(
        t
      )}`
    );
    return e;
  };
  /**
   * Fetches metrics analytics data based on the provided query parameters.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/presence_analytics/metrics?${queryParams}`
   *
   * @param {MetricRequestParams} queryParams - An object containing the query parameters for the API call.
   * @returns {Promise<Record<string, any>>} A promise that resolves to an object containing the metrics analytics data.
   */
  getMetricsAnalytics = async (t) => {
    const { data: e } = await this.get(
      `${r}/${a}?${s(t)}`
    );
    return e;
  };
  /**
   * Fetches keyword analytics data based on the provided query parameters.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/presence_analytics/keywords?${queryParams}`
   *
   * @param {KeywordRequestParams} queryParams - An object containing the query parameters for the request.
   * @returns {Promise<PaginatedResponse<AggregatedKeyword>>} A promise that resolves to an object containing the keyword analytics data.
   */
  getKeywordsAnalytics = async (t) => {
    const { data: e } = await this.get(
      `${r}/${c}?${s(t)}`
    );
    return e;
  };
}
export {
  $ as PresenceAnalytics
};
